import { createAction } from 'typesafe-actions';
import { IAuthState } from './types';

export const UPDATE_AUTH_STATE = 'UPDATE_AUTH_STATE';
export const updateAuthState = createAction(UPDATE_AUTH_STATE)<IAuthState>();

export const INIT_AUTH_STATE = 'INIT_AUTH_STATE';
export const initAuthState = createAction(INIT_AUTH_STATE)();
